import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./Federal.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
import Principle from "Components/Cards/Cards";
import Icon1 from "Assets/About/principle_1.png";
import Icon2 from "Assets/About/principle_2.png";
import Icon3 from "Assets/About/principle_3.png";
const Card = [
    {
        icon: Icon1,
        Content:
            "We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations.",
        heading: "We bring order to chaos",
    },
    {
        icon: Icon2,
        Content:
            "We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations.",
        heading: "We do it right the first time.",
    },
    {
        icon: Icon3,
        Content:
            "At Executive Tax and Accounting Services. there are no excuses. If you need a service provided, we will find a way to complete. it, Our paperwork is accurate and always up to date.",
        heading: "You need it? We provide it.",
    },
];
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Refund Policy</h3>
                </header>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div className={AboutClasses["content"]}>
                        <p>Effective Date: 01/01/2025</p>
                        <p>
                            At <b>Serene Tax LLC</b>, we value customer
                            satisfaction and aim to provide the highest quality
                            tax and financial services. This Refund Policy
                            outlines the terms and conditions under which
                            refunds may be issued.
                        </p>
                        <h4>1. General Refund Policy</h4>
                        <p>
                            Refunds are considered on a case-by-case basis for
                            services provided by <b>Serene Tax LLC</b>. To
                            request a refund, you must adhere to the conditions
                            outlined below.
                        </p>
                        <h4>2. Eligibility for Refunds</h4>
                        <p>
                            Refunds may be issued under the following
                            circumstances:
                        </p>
                        <ul>
                            <li>
                                <b>Service Not Rendered:</b>
                                If the service for which you have paid has not
                                yet been rendered.
                            </li>
                            <li>
                                <b>Error on Our Part:</b>
                                If an error occurred due to a mistake made by{" "}
                                <b>Serene Tax LLC</b> during the processing of
                                your payment or service.
                            </li>
                            <li>
                                <b>Prepaid Services:</b>
                                If you have prepaid for a service but decide to
                                cancel before the service begins, a refund may
                                be issued, less any applicable administrative
                                fees.
                            </li>
                        </ul>
                        <h4>3. Non-Refundable Scenarios</h4>
                        <p>
                            Refunds will not be issued under the following
                            circumstances:
                        </p>
                        <ul>
                            <li>
                                If services have already been rendered in full
                                or partially
                            </li>
                            <li>
                                For dissatisfaction with results that are
                                contingent upon external factors like tax
                                refunds determined by government agencies
                            </li>
                            <li>
                                You will receive a confirmation email or receipt
                                upon successful payment.
                            </li>
                            <li>
                                For late refund requests that do not comply with
                                the timelines outlined below.
                            </li>
                        </ul>
                        <h4>4. Refund Request Process</h4>
                        <p>To request a refund, please follow these steps:</p>
                        <ul>
                            <li>
                                Submit a written request via email to{" "}
                                <span
                                    style={{
                                        color: "blue",
                                        textDecoration: "underline",
                                    }}>
                                    support@serenetax.com
                                </span>{" "}
                                with in <b>14 days</b> of the payment date
                            </li>
                            <li>
                                Include the following details in your request:
                                <p>o Full name.</p>
                                <p>o Transaction date and amount.</p>
                                <p>o Reason for requesting the refund.</p>
                                <p>
                                    o Proof of payment (e.g., receipt or payment
                                    confirmation).
                                </p>
                            </li>
                            <li>
                                {" "}
                                Allow 7-10 business days for us to review your
                                request and respond.
                            </li>
                        </ul>
                        <h4>5. Refund Processing</h4>
                        <ul>
                            <li>
                                If your refund request is approved, the refund
                                will be processed to the original payment method
                                within <b>7-10 business days</b>.
                            </li>
                            <li>
                                Processing times may vary depending on your
                                financial institution.
                            </li>
                            <li>
                                Administrative fees may be deducted from the
                                refunded amount.
                            </li>
                        </ul>
                        <h4>6. Charge-backs and Disputes</h4>
                        <p>
                            Initiating a charge-back or payment dispute without
                            first contacting <b>Serene Tax LLC</b> to resolve
                            the issue may result in additional fees and
                            termination of future service eligibility.
                        </p>

                        <h4>7. Contact Us</h4>
                        <p>
                            If you have questions about this Refund Policy or
                            your eligibility, please contact us:
                        </p>
                        <ul>
                            <li>
                                Email:{" "}
                                <span
                                    style={{
                                        textDecoration: "underline",
                                        color: "blue",
                                    }}>
                                    support@serenetax.com/ contact@serenetax.com
                                </span>
                            </li>
                            <li>
                                <b>Phone</b>
                                +1 (262) 735-8874/ +1 (262) 735-8875
                            </li>
                            <li>
                                <b>Mailing Address</b> 42707 Wardlaw Ter,
                                Ashburn, Virginia, 20147, USA.
                            </li>
                        </ul>
                        <h4>8. Modifications to Policy</h4>
                        <p>
                            We reserve the right to amend this Refund Policy at
                            any time. Any changes will be effective immediately
                            upon posting on this page. Please review this policy
                            periodically for updates.
                        </p>
                        <h4>9. Governing Law</h4>
                        <p>
                            This Refund Policy is governed by the laws of the
                            <b>State of Virginia</b>. Any disputes related
                            torefunds shall be resolved under these laws.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
